import type { SuspenseLoadConfig } from '../schema/ErrorConfig';
import { type ErrorHandlerConfigType } from '../schema/ErrorConfig';

export const getSuspenseErrorConfig = (
    suspenseFallback: React.ComponentType,
    isFullScreen?: boolean
): SuspenseLoadConfig => ({
    configType: 1,
    SuspenseFallBackComponent: suspenseFallback,
    ...(isFullScreen && { errorScreen: { isFullScreen } }),
});
